export function removeSkuFromState(sku) {
    return function (state) {
        return Object.assign(Object.assign({}, state), { items: state.items.filter(item => item.sku !== sku) });
    };
}
